import React from 'react';
import { motion } from 'framer-motion';
import MotionSection from '../components/ui/MotionSection';

const Privacy = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen pt-20"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <MotionSection className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-light/60">Last updated: December 2024</p>
        </MotionSection>

        <MotionSection className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-bold mb-4">Information We Collect</h2>
              <p className="text-light/80 mb-4">
                We collect information you provide directly to us, such as when you create an account, 
                use our services, or contact us for support.
              </p>
              <ul className="list-disc list-inside space-y-2 text-light/80">
                <li>Account information (name, email, password)</li>
                <li>Email content you generate through our service</li>
                <li>Usage data and analytics</li>
                <li>Payment information (processed securely through Stripe)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">How We Use Your Information</h2>
              <ul className="list-disc list-inside space-y-2 text-light/80">
                <li>Provide and improve our AI email generation service</li>
                <li>Process payments and manage your account</li>
                <li>Send important updates about our service</li>
                <li>Analyze usage patterns to enhance user experience</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Data Security</h2>
              <p className="text-light/80">
                We implement appropriate security measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction. All data 
                is encrypted in transit and at rest.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Third-Party Services</h2>
              <p className="text-light/80 mb-4">
                We use trusted third-party services to provide our functionality:
              </p>
              <ul className="list-disc list-inside space-y-2 text-light/80">
                <li>OpenAI for AI email generation</li>
                <li>Stripe for payment processing</li>
                <li>Analytics services for usage insights</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Your Rights</h2>
              <p className="text-light/80 mb-4">You have the right to:</p>
              <ul className="list-disc list-inside space-y-2 text-light/80">
                <li>Access your personal data</li>
                <li>Correct inaccurate information</li>
                <li>Delete your account and data</li>
                <li>Export your data</li>
                <li>Opt out of marketing communications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
              <p className="text-light/80">
                If you have questions about this Privacy Policy, please contact us at{' '}
                <a href="mailto:privacy@coldmail.ai" className="text-primary hover:underline">
                  privacy@coldmail.ai
                </a>
              </p>
            </section>
          </div>
        </MotionSection>
      </div>
    </motion.div>
  );
};

export default Privacy;